import { Box, Button, Text } from '@opendoor/bricks-next';

import { OdProtosSellReceptionData_SellerInput_Channel } from '__generated__/athena';

import { EntryComponent } from 'cms/entries/entries';

import { IComponentSimpleCta } from '../../declarations/contentful';
import NewSellerFlowAddressInput from '../shared/NewSellerFlowAddressInput';
import { useStickyAddress } from './StickyAddressContext';

const renderSimpleCTA = (entry: IComponentSimpleCta) => {
  return <SimpleCTAInner entry={entry} />;
};

const SimpleCTAInner = ({ entry }: { entry: IComponentSimpleCta }) => {
  const { fields } = entry;
  const stickyAddress = useStickyAddress();

  return (
    <Box className="embedded-entry-wrapper" $platform-web={{ gridColumn: '5 / -2' }}>
      <Box
        padding={stickyAddress ? '$12x' : '$10x'}
        alignItems={stickyAddress ? 'stretch' : 'center'}
        backgroundColor="$backgroundTertiary"
        borderRadius="$16x"
        flexDirection={'column'}
        shadowOffset={stickyAddress ? { width: 0, height: 4 } : undefined}
        shadowRadius={stickyAddress ? 24 : undefined}
        {...(stickyAddress ? { $largerThanMD: { display: 'none' } } : {})}
      >
        {fields.headline && (
          <Text
            tag="h5"
            typography="$subheaderMedium"
            textAlign={stickyAddress ? 'left' : 'center'}
            color="$contentPrimary"
            marginBottom={stickyAddress ? '$4x' : undefined}
          >
            {fields.headline}
          </Text>
        )}
        {fields.description && (
          <Text
            tag="p"
            textAlign={stickyAddress ? 'left' : 'center'}
            marginVertical={stickyAddress ? undefined : '$5x'}
            marginBottom={stickyAddress ? '$8x' : undefined}
            typography="$bodyMedium"
            $largerThanXS={stickyAddress ? undefined : { typography: '$bodyLarge' }}
            color="$contentTertiary"
          >
            {fields.description}
          </Text>
        )}
        {stickyAddress ? (
          <Box width="100%" maxWidth={480}>
            <NewSellerFlowAddressInput
              inputLocation="article-sticky-address"
              trackingTaxonomy="article_sticky_address"
              analyticsPrefix={
                fields.headline
                  ?.toLowerCase()
                  .replace(/[^a-z0-9]+/g, '-')
                  .replace(/^-|-$/g, '') ?? 'article-inline-cta'
              }
              placeholder={
                stickyAddress.fields?.addressInputPlaceholderText ?? 'Enter your home address'
              }
              hideLabel
              trackingKeywords={stickyAddress.fields?.trackingKeyword}
              channel={
                stickyAddress.fields?.channel as
                  | OdProtosSellReceptionData_SellerInput_Channel
                  | undefined
              }
              size="small"
            />
          </Box>
        ) : (
          fields.ctaLink &&
          fields.ctaText && (
            <Button
              onPress={() => {
                window.open(fields.ctaLink, '_blank');
              }}
              analyticsName="simple-cta-get-offer-button"
              variant="primary"
              size="small"
              label="Get a cash offer"
            />
          )
        )}
      </Box>
    </Box>
  );
};

const SimpleCTA: EntryComponent<IComponentSimpleCta> = {
  render: renderSimpleCTA,
};

export default SimpleCTA;
